var _rect, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _ellipse, _path6, _circle4, _ellipse2, _ellipse3, _path7, _ellipse4, _circle5, _ellipse5, _circle6, _path8, _path9, _path10, _path11, _g, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#2f5f68"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#47727a",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#555d6b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88L60 112L72 88L66 86L60 94L54 86Z",
    fill: "#f4f1ea"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94L56 100L60 118L64 100Z",
    fill: "#c8412b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90L56 124L36 124C30 110 34 96 42 90ZM78 90L64 124L84 124C90 110 86 96 78 90Z",
    fill: "#444a55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#d8b99d"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#f6d3b3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90L48 84V96ZM60 90L72 84V96Z",
    fill: "#c8412b"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 90,
    r: 3,
    fill: "#963020"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#bfa48b",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48Q51 44 57 48",
    stroke: "#2a1d1a",
    strokeWidth: 3.8000000000000003,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63 48Q69 44 75 48",
    stroke: "#2a1d1a",
    strokeWidth: 3.8000000000000003,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69L66 69",
    stroke: "#2a1d1a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66C51 60 57 62 60 65C63 62 69 60 73 66C68 70 62 67 60 67C58 67 52 70 47 66Z",
    fill: "#2a1d1a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 0.18,
    stroke: "#3b3b4a",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 48,
    width: 16,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 48,
    width: 16,
    height: 12,
    rx: 3
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59 52L61 52M43 51L38 49M77 51L82 49",
    stroke: "#3b3b4a",
    strokeWidth: 2,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait8);
export default __webpack_public_path__ + "static/media/player-portrait-8.0c1bf368dc3999d3de520da2bb96495d.svg";
export { ForwardRef as ReactComponent };